<script>
import { nextTick } from "vue";
import { getDoluFromDbase, readAllCategories, readAllPosts } from '@/services/MindMovieServices';
import SinglePost from './SinglePost.vue';

export default {
  components: {
    SinglePost,
  },
  data() {
    return {
      uId: localStorage.getItem('uId'),
      token: localStorage.getItem('idToken'),
      // =======
      dbaseDolu: null,
      localDoluPosts: localStorage.getItem('doluPosts'),
      localDoluCategories: localStorage.getItem('doluCategories'),
      // =======
      allPosts: {},
      filteredPosts: {},
      randomizedPosts: {},
      paginatedPosts: {},
      currentPage: 1,
      postsPerPage: 15,

      posts: {},
      postsIds: [],

      userWantsToApplyFilters: false,
      idsOfUrlFilters: [],
      selectedFilters: [],

      categories: {},
      categoriesObjectNameIsKeyIdIsValue: {},

      finishedDbCalls: false,
    };
  },
  computed: {
    localPosts() {
      const lp = localStorage.getItem('posts');
      return lp ? JSON.parse(lp) : null;
      // return {};
    },
    localCategories() {
      const lc = localStorage.getItem('categories');
      return lc ? JSON.parse(lc) : null;
    },
    totalPages() {
      return Math.ceil(this.filteredPostsIds.length / this.postsPerPage);
    },
    filteredPostsIds() {
      return Object.keys(this.filteredPosts);
    },
    randomizedPostsIds() {
      return this.randomizeThePosts(this.filteredPostsIds);
    },
    paginatedPostsIds() {
      const start = (this.currentPage - 1) * this.postsPerPage;
      const end = start + this.postsPerPage;
      return this.randomizedPostsIds.slice(start, end);
    },
  },
  watch: {
    // if URL query changes (for example, user visits /mindmovie?filters=cat1,cat2)
    $route() {
      this.selectedFilters = [];
      const queryFilters = this.$route.query.filters;
      if (queryFilters) {
        // filter the posts, by selected categories
        this.selectedFilters = queryFilters.split(',');
        for (let f of this.selectedFilters) {
          this.idsOfUrlFilters.push(this.categoriesObjectNameIsKeyIdIsValue[f]);
        }
      }
      this.filterThePosts();
    },
  },
  methods: {

    async getLatestCategoriesFromDbase() {
      if (!this.localCategories || !this.localDoluCategories || this.dbaseDolu.categories !== this.localDoluCategories) {
        this.categories = await readAllCategories(this.uId, this.token);
        localStorage.setItem('categories', JSON.stringify(this.categories));
        localStorage.setItem('doluCategories', this.dbaseDolu.categories);
      }
      else if (this.dbaseDolu.categories === this.localDoluCategories) {
        this.categories = this.localCategories;
      }
    },

    async getLatestPostsFromDbase() {
      if (!this.localPosts || !this.localDoluPosts || this.dbaseDolu.posts !== this.localDoluPosts) {
        // get from dbase, then set localStorage: posts, dolu.posts
        const posts = await readAllPosts(this.uId, this.token);
        if (posts) {
          this.allPosts = posts;
          localStorage.setItem('posts', JSON.stringify(this.allPosts));
          localStorage.setItem('doluPosts', this.dbaseDolu.posts);
        }
      }
      else if (this.dbaseDolu.posts === this.localDoluPosts) {
        this.allPosts = this.localPosts;
      }

      this.postsIds = this.randomizeThePosts(Object.keys(this.allPosts));

    },

    randomizeThePosts(array) {
      let currentIndex = array.length;
      let randomIndex;

      // While there remain elements to shuffle.
      while (currentIndex !== 0) {
        // Pick a remaining element.
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
          array[randomIndex],
          array[currentIndex],
        ];
      }

      return array;
    },

    filterThePosts() {
      // console.log('*** selectedFilters ***', this.selectedFilters);
      if (this.selectedFilters.length > 0) {
        let postsThatHaveFilterCategory = {};
        for (let i of this.postsIds) {
          if (this.allPosts[i].categories) {
            const hasFilter = this.allPosts[i].categories.some(postCat => this.idsOfUrlFilters.includes(postCat));
            if (hasFilter) {
              postsThatHaveFilterCategory[i] = this.allPosts[i];
            }
          }
        }
        if (Object.keys(postsThatHaveFilterCategory).length) {
          this.filteredPosts = postsThatHaveFilterCategory;
        }
      }
      else {
        this.filteredPosts = this.allPosts;
      }
    },

    cancelFilters() {
      console.log('*** cancelFilters() *****');
      this.userWantsToApplyFilters = false;
      this.selectedFilters = [];
    },
    applyFilters() {
      if (this.selectedFilters.length > 0) {
        const filters = [];
        for (let f of this.selectedFilters) {
          filters.push(this.categoriesObjectNameIsKeyIdIsValue[f]);
        }
        this.$router.push(`/mindmovie?filters=${this.selectedFilters.join(',')}`);
      } else {
        this.$router.push('/mindmovie');
      }
      this.userWantsToApplyFilters = false;

      // console.log('*** applyFilters() >> newRoute ***', newRoute);
    },

    async goToPage(page) {
      await nextTick();
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    },

  },
  async mounted() {
    console.clear();

    // first, get the posts && categories
    this.dbaseDolu = await getDoluFromDbase(this.uId, this.token);
    await this.getLatestPostsFromDbase();
    await this.getLatestCategoriesFromDbase();
    // create an array of categories' IDs
    const categoriesIds = Object.keys(this.categories);
    for (let id of categoriesIds) {
      this.categoriesObjectNameIsKeyIdIsValue[this.categories[id].name] = id;
    }

    // next, filter the posts
    const queryFilters = this.$route.query.filters;
    if (queryFilters) {
      // filter the posts, by selected categories
      this.selectedFilters = queryFilters.split(',');
      for (let f of this.selectedFilters) {
        this.idsOfUrlFilters.push(this.categoriesObjectNameIsKeyIdIsValue[f]);
      }
    }
    this.filterThePosts();

    // third, randomize the posts



    // lastly, paginate the posts

    // finally, display the posts
    this.finishedDbCalls = true;
  },


}
</script>

<template>
  <div class="bg-black text-white">

    <h1 class="text-center pt-3">mind movie</h1>

    <!-- DISPLAY ALL POSTS -->
    <div v-if="finishedDbCalls" id="display-all-posts-container" class="px-4">

      <!-- APPLY FILTERS -->
      <div v-if="userWantsToApplyFilters" class="apply-filters-container">
        <v-combobox
          v-model="selectedFilters"
          :items="Object.keys(categoriesObjectNameIsKeyIdIsValue)"
          label="Select Filter(s)"
          chips
          multiple
          clearable
          bg-color="blue-lighten-4"
        ></v-combobox>
        <div class="filters-actions-container d-flex justify-space-between align-start">
          <p @click="cancelFilters"
            class="text-red-lighten-2 font-italic"
          >Cancel</p>
          <v-btn @click="applyFilters"
            color="green-lighten-3"
            density="compact"
            variant="outlined"
          >Apply Filter(s)</v-btn>
        </div>
      </div>
      <div v-else
        @click="userWantsToApplyFilters = true"
        class="apply-filters-container text-center mt-2 text-blue-lighten-4"
      >Filters <v-icon>mdi-filter-variant</v-icon>
      </div>


<!--      <SinglePost v-for="id of postsIds" :key="id"-->
      <div v-for="id of paginatedPostsIds" :key="id">
        <SinglePost
          :postId="id"
          :propPost="filteredPosts[id]"
          :allCategories="categories"
          :allCategoriesByName="categoriesObjectNameIsKeyIdIsValue" />
      </div>


      <!-- Vuetify Pagination -->
      <div v-if="totalPages > 1" class="d-flex justify-center mt-8">
        <v-pagination
          v-model="currentPage"
          :length="totalPages"
          @update:model-value="goToPage"
          total-visible="3"
          rounded="circle"
          next-icon="mdi-chevron-right"
          prev-icon="mdi-chevron-left"
        />
      </div>

    </div> <!-- end #DisplayAllPosts -->


  </div>
</template>

<style scoped lang="scss">
#display-all-posts-container {
  padding-bottom: 120px;
}

.filters-actions-container {
  margin-top: -12px;
}
.apply-filters-container {
  margin-bottom: 36px;
}
</style>
